import React, { useState, useCallback } from "react";
import Modal from "react-modal";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";

Modal.setAppElement("#root");

export default function CropModal({ isOpen, imageSrc, onCancel, onCropComplete }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleSave = async () => {
    try {
      const { blob, fileUrl } = await getCroppedImg(imageSrc, croppedAreaPixels);
      onCropComplete(blob, fileUrl);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      contentLabel="Crop Image"
      style={{
        overlay: { backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000 },
        content: { maxWidth: 700, margin: "auto", borderRadius: "10px", padding: "1rem", inset: "50% auto auto 50%", transform: "translate(-50%, -50%)",zIndex: 1001 }
      }}
    >
      <h2 className="text-center mb-3" style={{ textAlign: "center" }}>Crop Image</h2>

      <div style={{ position: "relative", width: "100%", height: 400, background: "#333" }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
        />
      </div>

      {/* Controls */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "1rem" }}>
        <button onClick={onCancel} style={{ padding: "0.5rem 1rem", borderRadius: "5px", border: "none", backgroundColor: "#6c757d", color: "#fff", cursor: "pointer" }}>Cancel</button>

        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexGrow: 1, marginLeft: "1rem", marginRight: "1rem" }}>
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            style={{ flexGrow: 1 }}
          />
          <button onClick={handleSave} style={{ padding: "0.5rem 1rem", borderRadius: "5px", border: "none", backgroundColor: "#007bff", color: "#fff", cursor: "pointer" }}>Save</button>
        </div>
      </div>
    </Modal>
  );
}
